export const throttleTime = {
    standard: 1000,
};
//# sourceMappingURL=throttle.js.map